export default "__VITE_PUBLIC_ASSET__d3e54ce4__"